export function extractRoleFromClientId(clientId: string): string | null {
  const parts = clientId.split('|');
  const role = parts[2]?.trim();
  return role || null;
}

export function extractSessionIdentifierFromClientId(clientId: string): string | null {
  const match = clientId.match(/^sess:([^|]+)/);
  return match ? match[1] : null;
}

export function extractWebinarIdFromClientId(clientId: string): number | null {
  const match = clientId.match(/webinar:(\d+)/);
  return match ? parseInt(match[1], 10) : null;
}
